import { render, staticRenderFns } from "./creatorProfiles.vue?vue&type=template&id=4fcbb65c&scoped=true"
import script from "./creatorProfiles.vue?vue&type=script&lang=js"
export * from "./creatorProfiles.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fcbb65c",
  null
  
)

export default component.exports